import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralResModel } from 'src/app/_models';
import { HrEmpVerify } from '../../_models/radiologist-signup/HrEmpVerify';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class UserVerifyService {

  private apiPATH = "UserVerify/";
  constructor(private router: Router, private api: ApiService) {}

  SendVerificationCode(userVerify:HrEmpVerify){
    return this.api.post<GeneralResModel<HrEmpVerify>>(`${this.apiPATH}addUserVerificationInfo`,userVerify);
  }


  verifyOTP(userVerify:HrEmpVerify){
    return this.api.post<GeneralResModel<HrEmpVerify>>(`${this.apiPATH}verifyOTP`,userVerify);
  }
}
